import { createFileRoute } from '@tanstack/react-router'
import { AuditScreen } from '@/features/audit/audit'

/**
 * Route shell for the platform audit screen — plan 05 Task 13.
 *
 * Per the route-shell rule, this file is a route definition and a render.
 * The screen lives in `src/features/audit/`.
 */
export const Route = createFileRoute('/_authenticated/audit')({
  component: AuditScreen,
})
